(() => {
  'use strict';
  const HANDLES = Object.freeze({
    hard_top: 'daktent-hard-top',
    soft_top: 'soft-top-daktent',
    lightweight: 'triangle-soft-top-daktent',
    soft_top_small: 'daktent-soft-top-small'
  });
  const VARIANT_IDS = Object.freeze({soft_top: 53169876828424});
  const cache = new Map();
  const get = async url => {
    if (!cache.has(url)) cache.set(url, fetch(url, {credentials:'same-origin'}).then(response => {
      if (!response.ok) throw new Error(`Tent product HTTP ${response.status}`);
      return url.endsWith('.js') ? response.json() : response.text();
    }).catch(error => {cache.delete(url); throw error}));
    return cache.get(url);
  };
  const choose = (baseRoofbarLoadKg, resultSource) => {
    const rule = resultSource === 'fallback_atera' ? 'fallback_atera' :
      Number.isFinite(baseRoofbarLoadKg) && baseRoofbarLoadKg >= 90 ? 'high_load' : 'low_load';
    return {rule, keys:rule === 'high_load' ? ['hard_top','soft_top'] :
      rule === 'fallback_atera' ? ['lightweight','soft_top'] : ['lightweight','soft_top_small']};
  };
  const clean = value => String(value || '').replace(/\s+/g,' ').trim();
  function specsFromHtml(html) {
    const document = new DOMParser().parseFromString(html,'text/html');
    const spec = {};
    for (const details of document.querySelectorAll('accordion-custom details')) {
      const heading=clean(details.querySelector('summary')?.textContent).toLowerCase();
      if (!/^(functies|afmetingen en gewicht)$/.test(heading)) continue;
      for (const item of details.querySelectorAll('li')) {
        const label=clean(item.querySelector('strong')?.textContent).replace(/:$/,'').toLowerCase();
        const value=clean(item.textContent).replace(/^[^:]+:\s*/,'');
        if (label==='gewicht' && /^\d+(?:[,.]\d+)?\s*kg\b/i.test(value)) spec.weightKg=value;
        if (label==='opzetten' && value) spec.openingTime=value;
        if (label==='matrasmaat' && value) spec.mattressSize=value;
      }
    }
    return spec;
  }
  async function resolve(key) {
    const handle=HANDLES[key];
    if (!handle) throw new Error('Unknown tent key');
    const path=`/products/${handle}`;
    const [product, html]=await Promise.all([get(`${path}.js`),get(path)]);
    if (!product?.id || product.handle!==handle || !Array.isArray(product.variants)) throw new Error(`Invalid Shopify tent: ${handle}`);
    const variant=VARIANT_IDS[key] ? product.variants.find(item=>item.id===VARIANT_IDS[key] && item.available) :
      product.variants.find(item=>item.available) || product.variants[0];
    if (!variant?.id || !Number.isInteger(variant.price)) throw new Error(`Missing Shopify tent price: ${handle}`);
    const image=variant.featured_image?.src || product.featured_image || product.images?.[0] || '';
    return {
      key,productId:product.id,variantId:variant.id,sku:variant.sku||'',title:product.title,
      url:`${path}?variant=${variant.id}`,imageUrl:image.startsWith('//')?`https:${image}`:image,
      imageAlt:product.title,priceCents:variant.price,compareAtPriceCents:variant.compare_at_price || null,
      currency:globalThis.Shopify?.currency?.active || 'EUR',...specsFromHtml(html)
    };
  }
  window.FitmentGlobalTents={choose,resolve};
})();
